import { AlertCircle } from 'lucide-react';

interface ErrorMessageProps {
  message: string | null;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="bg-red-50 text-red-800 rounded-lg p-4 flex items-center">
        <AlertCircle className="h-5 w-5 text-red-400 mr-2" />
        <span>{message || 'An error occurred while loading the PDF.'}</span>
      </div>
    </div>
  );
}